module.exports = __webpack_public_path__ + "static/media/llamada_entrada.8073065a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallRecord/llamada_entrada.svg
// module id = 1741
// module chunks = 0